"use client";

import { c as _c } from "react/compiler-runtime";
import type { CtaButtonEntry, CtaExperiences } from "./CTAButton";
import { PersonalizedCtaButton } from "./PersonalizedCtaButton";
export type CtaExposures = Record<string, Record<string, number>>;
interface Props {
  entry: CtaButtonEntry;
  experiences?: CtaExperiences;
  exposures?: Record<string, number>;
  className?: string;
}
export default function CTAButtonPersonalized(t0) {
  const $ = _c(7);
  const {
    entry,
    experiences,
    exposures,
    className
  } = t0;
  const entryExperiences = experiences ?? entry.fields.nt_experiences;
  let t1;
  if ($[0] !== exposures) {
    t1 = exposures ?? {};
    $[0] = exposures;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== entry || $[4] !== entryExperiences || $[5] !== t1) {
    t2 = <PersonalizedCtaButton entry={entry} experiences={entryExperiences} exposures={t1} className={className} />;
    $[2] = className;
    $[3] = entry;
    $[4] = entryExperiences;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}